<template>
	<c-select-picker ref="outletPicker" title="分配至网点" :clear="false" height="60vh" :search="{async: true}" :disabled="disableOptions" @search="searchOutlet" @resolve="resolveHandle">
		<template #option="{data, selected, disabled}">
			<select-option
				:name="data.name"
				:info="[
					`负责人：${data.data.principal_user_name || '-'}`
				]"
				:selected="selected"
				:disabled="disabled"
			></select-option>
		</template>
	</c-select-picker>
</template>

<script>
	export default {
		data() {
			return {
				disableOptions: []
			}
		},
		
		methods: {
			open(id) {
				this._id = id;
				this.$refs.outletPicker.open();
			},

			searchOutlet(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_OUTLET',
						keyword
					},
					success: data => {
						this.disableOptions = data.filter(item => !item.data.principal_user_name).map(item => item.value);
						resolve(data);
					}
				})
			},

			resolveHandle({data}) {
				this.request({
					url: '/aftersale/apply/authorized_outlet',
					data: {
						id: this._id,
						authorized_outlet_id: data.id
					},
					loading: true,
					success: () => {
						this.$message({
							message: '分配网点成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>